// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"c3fe5ec5","453":"08ca1245","667":"daeea698","977":"1c74eb9d"}[chunkId] + ".chunk.js";
};